import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { InputField } from '../inputs/standard';
import Calendar from '../components/Calendar';
import ErrorList from './ErrorList';
import AuthService from '../services/api/auth';
const countries = AuthService.getCountries();
const states = AuthService.getStates();
let DriversLicenseCheckForm = props => {
    const { handleSubmit } = props;
    let errors = Object.keys(props.errors).map(key => {
        return window.VULOG_TRANSLATE(`${key} ${props.errors[key]}`);
    });

    const countryName = props && props.formValues && props.formValues.Country;

    if (props.error) {
        errors.push(window.VULOG_TRANSLATE(props.error));
    }

    return (
        <form onSubmit={handleSubmit}>
            {window.VULOG_CONFIG && window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
            <div className="form-row mb-2">
                <label htmlFor="issuing-country" className="blue small col-4 mb-0">
                    {window.VULOG_TRANSLATE('Issuing Country')}
                </label>
                <div className="col">
                    <Field name={'Country'} component={'select'} className={'form-control'}>
                        {countries.map(country => (
                            <option key={country.value} value={country.value}>
                                {country.label}
                            </option>
                        ))}
                    </Field>
                </div>
            </div>
            {window.VULOG_CONFIG && window.VULOG_CONFIG.CHECKR_ENABLED && countryName === 'USA' && (
                <div className="form-row mb-2">
                    <label htmlFor="issuing-state" className="blue small col-4 mb-0">
                        {window.VULOG_TRANSLATE('Issuing State')}
                    </label>
                    <div className="col">
                        <Field name={'IssuingStateCode'} component={'select'} className={'form-control'}>
                            {states.map(state => (
                                <option key={state.value} value={state.value}>
                                    {state.label}
                                </option>
                            ))}
                        </Field>
                    </div>
                </div>
            )}
            <div className="form-row mb-2">
                <label htmlFor="license-number" className="blue small col-4 mb-0">
                    {window.VULOG_TRANSLATE('License number')}
                </label>
                <div className="col">
                    <Field
                        component={InputField}
                        type="text"
                        name="DocumentNumber"
                        readonly
                        className="form-control"
                        id="license-number"
                        value="0X34227GG8U7"
                    />
                </div>
            </div>
            {window.VULOG_CONFIG && window.VULOG_CONFIG.ENABLE_DL_CLASS ? (
                <div className="form-row mb-2">
                    <label htmlFor="license-number" className="blue small col-4 mb-0">
                        {window.VULOG_TRANSLATE('License class')}
                    </label>
                    <div className="col">
                        <Field
                            component={InputField}
                            type="text"
                            name="LicenseClass"
                            readonly
                            className="form-control"
                            id="license-class"
                        />
                    </div>
                </div>
            ) : null}
            {!props.hideExpirationDate && (
                <div className="form-row mb-2">
                    <label htmlFor="expiration-date" className="blue small col-4 mb-0">
                        {window.VULOG_TRANSLATE('Expiration Date')}
                    </label>
                    <div className="col">
                        <Field
                            name="ExpirationDate"
                            disablePast
                            isUsFormat={window.VULOG_CONFIG.US_DATE_FORMAT}
                            component={Calendar}
                        />
                    </div>
                </div>
            )}
            <div className="form-row mb-2">
                <label htmlFor="first-name" className="blue small col-4 mb-0">
                    {window.VULOG_TRANSLATE('First Name')}
                </label>
                <div className="col">
                    <Field
                        component={InputField}
                        name={'GivenName'}
                        type="text"
                        className="form-control"
                        id="first-name"
                    />
                </div>
            </div>
            <div className="form-row mb-2">
                <label htmlFor="last-name" className="blue small col-4 mb-0">
                    {window.VULOG_TRANSLATE('Last Name')}
                </label>
                <div className="col">
                    <Field component={InputField} name={'Surname'} className="form-control" id="last-name" />
                </div>
            </div>
            <div className="form-row mb-2">
                <label htmlFor="birth-date" className="blue small col-4 mb-0">
                    {window.VULOG_TRANSLATE('Birth Date')}
                </label>
                <div className="col">
                    <Field
                        name="BirthDate"
                        disableFuture
                        isUsFormat={window.VULOG_CONFIG.US_DATE_FORMAT}
                        component={Calendar}
                    />
                </div>
            </div>
            {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
        </form>
    );
};

DriversLicenseCheckForm = reduxForm({
    // a unique name for the form
    form: 'drivers-license-check',
})(DriversLicenseCheckForm);

export default DriversLicenseCheckForm;
